export default __webpack_public_path__ + "static/media/logo_branca_passarela_44.1d52b88b.png";